<div class="section-5 mat-padding-2">
  <div class="container mat-padding-2">
    <div class="text-center mat-display-1 read">
      En choisissant la <b>Formation Le Robert</b>, vous optez pour une
      <b>certification reconnue</b> au niveau international et un
      <b>dispositif complet, éligible au CPF</b> pour les salariés, demandeurs
      d’emploi et alternants.
    </div>

    <div class="text-center mat-h1 read">
      Un programme d’apprentissage composé par les auteurs et les éditeurs Le
      Robert, qui mettent au service des apprenants 70 ans d’expertise
      linguistique et pédagogique en langue française.
    </div>
  </div>
</div>

<div class="certifications text-center mat-padding-2">
  <div class="container mat-padding-2">
    <div
      class="text-center mat-display-1 bold"
      style="margin-bottom: 22px; color: black;"
    >
      Nos labels qualité et certifications
    </div>

    <div
      class="images"
      fxLayout="row wrap"
      fxLayoutAlign="center center"
      fxLayoutGap="64px grid"
      fxLayoutGap.xs="32px grid"
    >
      <img
        *ngFor="let logo of logos"
        height="132px"
        [src]="'/assets/lerobert/img/landing/' + logo.src"
      />
    </div>

    <div class="mat-caption">
      La Formation Le Robert, une marque commerciale de l’organisme de formation
      SEJER, a obtenu la certification Qualiopi en décembre 2021 (n°
      2112_CN_02965 d’agrément) au titre de la catégorie actions de formation.
      Note moyenne obtenue depuis janvier 2022 : 4,5/5 (dernière mise à jour :
      juin 2022). Plus d’informations.
    </div>
  </div>
</div>
